import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const StickyReportCTA = () => {
  const { t } = useT();
  const loc = useLocation();
  if (loc.pathname === "/report" || loc.pathname.startsWith("/loss/")) return null;
  return (
    <Link
      to="/#loss-categories"
      className="sm:hidden fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#FF3B30] px-5 py-3 text-sm font-bold text-white shadow-2xl shadow-red-500/30 pulse-red"
      data-testid="sticky-report-btn"
    >
      <ShieldAlert className="h-4 w-4" />
      {t.nav.reportCta}
    </Link>
  );
};

export default StickyReportCTA;
